// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3574":"888d5826","6497":"888d5826","7437":"888d5826"}[chunkId] + ".chunk.css";
};